<template>
  <div>
    <h2>{{ i18n.t('/stockdashboard/reservationstatus/titleids') }}</h2>
    <dl>
      <dt>{{ i18n.t('/stockdashboard/reservationstatus/status') }}</dt>
      <dd>{{ translatedReservationStatus }}</dd>
      <dt>{{ i18n.t('/stockdashboard/reservationstatus/ids/enddate') }}</dt>
      <dd>{{ stockCar.Reservation.ExpiresAt }}</dd>
      <dt>{{ i18n.t('/stockdashboard/reservationstatus/ids/dealer') }}</dt>
      <dd>{{ stockCar.Reservation.DealerName }}</dd>

      <dt>{{ i18n.t('/stockdashboard/reservationstatus/logisticinfo') }}</dt>
      <dd>&nbsp;</dd>
      <dt>{{ i18n.t('/stockdashboard/reservationstatus/ids/statusmessage') }}</dt>
      <dd>&nbsp;</dd>
    </dl>

    <template v-if="syntecReservation">
      <h2>{{ i18n.t('/StockDashboard/ReservationStatus/TitleSyntec') }}</h2>
      <dl>
        <dt>{{ i18n.t('/StockDashboard/ReservationStatus/CarLocation') }}</dt>
        <dd>{{ syntecReservation.LocationDealer }}</dd>
        <dt>{{ i18n.t('/StockDashboard/ReservationStatus/Establishment') }}</dt>
        <dd>{{ syntecReservation.Establishment }}</dd>
        <dt>{{ i18n.t('/StockDashboard/ReservationStatus/Reserved') }}</dt>
        <dd>
          {{
            syntecReservation.Reserved
              ? i18n.t('/StockDashboard/ReservationStatus/ReservedYes')
              : i18n.t('/StockDashboard/ReservationStatus/ReservedNo')
          }}
        </dd>

        <dt>
          {{ i18n.t('/StockDashboard/ReservationStatus/SoldSubjectToFinancing') }}
        </dt>
        <dd>
          {{
            syntecReservation.SoldSubjectToFinancing
              ? i18n.t('/StockDashboard/ReservationStatus/SoldSubjectToFinancingYes')
              : i18n.t('/StockDashboard/ReservationStatus/SoldSubjectToFinancingNo')
          }}
        </dd>
        <dt>{{ i18n.t('/StockDashboard/ReservationStatus/EndDate') }}</dt>
        <dd>{{ formatDate(syntecReservation.ExpiresAt) }}</dd>
      </dl>
    </template>

    <h2>{{ i18n.t('/StockDashboard/ReservationStatus/TitleCST') }}</h2>
    <table>
      <thead>
        <tr>
          <th>{{ i18n.t('/StockDashboard/ReservationStatus/Status') }}</th>
          <th>{{ i18n.t('/StockDashboard/ReservationStatus/QuoteId') }}</th>
          <th>{{ i18n.t('/StockDashboard/ReservationStatus/Establishment') }}</th>
          <th>{{ i18n.t('/StockDashboard/ReservationStatus/DeliveryDate') }}</th>
          <th>{{ i18n.t('/StockDashboard/ReservationStatus/ExpireDate') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="quote in stockCarQuotes" :key="quote.QuoteId">
          <td>{{ quote.Status }}</td>
          <td>{{ quote.QuoteId }}</td>
          <td>{{ quote.EstablishmentID }}</td>
          <td>{{ formatDate(quote.DeliveryDate) }}</td>
          <td>{{ formatDate(quote.ExpireDate) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import moment from 'moment'
import ReservationStatusNew from '@/helpers/enums/reservationStatusNew'
import StockCarsServiceNew from '@/services/StockCarsServiceNew'

export default {
  components: {},
  props: {
    stockCar: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      syntecReservation: null,
      stockCarQuotes: [],
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
  computed: {
    translatedReservationStatus() {
      if (!this.stockCar || !this.stockCar.Reservation || !this.stockCar.Reservation.Status) {
        return this.i18n.t('/StockDashboard/ReservationStatus/Unknown') // Fallback if data is missing
      }

      const statusEntry = Object.values(ReservationStatusNew).find(
        (status) => status.value === this.stockCar.Reservation.Status
      )

      return statusEntry ? this.i18n.t(statusEntry.labelKey) : this.stockCar.Reservation.Status
    },
  },
  async mounted() {
    if (!this.stockCar?.CommissionNumber || !this.stockCar?.CommissionYear) return

    try {
      this.syntecReservation = await StockCarsServiceNew.getSyntecReservation(
        this.stockCar.CommissionNumber
      )

      const quotesResponse = await StockCarsServiceNew.getStockCarQuotes(
        this.stockCar.CommissionNumber,
        this.stockCar.CommissionYear
      )
      this.stockCarQuotes = quotesResponse || []
    } catch (error) {
      console.error('Error fetching reservation data:', error)
    }
  },
  methods: {
    formatDate(value) {
      return value == null ? '' : moment(value).format('l')
    },
  },
}
</script>

<style lang="scss" scoped>
dl {
  display: grid;
  grid-template-columns: 8em auto;
  margin-bottom: 2em;
}

dt,
dd {
  padding: 0.5em 0;
  border-bottom: 1px solid #dae2e5;
}

dt {
  font-weight: $font-weight-bold;
  padding-right: 0.5em;
}

h2 {
  font-size: 1.25em;
}

.loader {
  margin: 0;
  width: 2.5em;
  height: 1.5em;
}
</style>
